import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/images/LogoCapitole.png'


const _hoisted_1 = { class: "tw-header-logo" }
const _hoisted_2 = { class: "tw-header-nav flex-grow-1 justify-end" }
const _hoisted_3 = { class: "tw-header-actions" }
const _hoisted_4 = { class: "align-items-center d-flex" }
const _hoisted_5 = { class: "tw-theme-switch-wrap" }
const _hoisted_6 = ["aria-pressed", "aria-label"]
const _hoisted_7 = {
  class: "tw-theme-switch__thumb",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  class: "tw-theme-switch__thumb-icon",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = { class: "theme-1" }
const _hoisted_12 = { class: "card tw-notifications-wrapper" }
const _hoisted_13 = { class: "card-header bg-white d-flex justify-content-between align-items-center pb-0" }
const _hoisted_14 = { class: "card-title mb-0 w-100" }
const _hoisted_15 = { class: "font-size-14 font-medium" }
const _hoisted_16 = { class: "font-size-12 text-muted" }
const _hoisted_17 = { class: "align-content-center d-flex justify-content-between mt-2" }
const _hoisted_18 = { class: "input-group input-group-sm border default-border-radius" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "align-items-center border d-flex default-border-radius p-1 ml-1 cursor-pointer" }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "nav nav-tabs tw-tabs-nav mb-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "tw-mark-all-read-bar"
}
const _hoisted_25 = { class: "tw-mark-all-read-bar__left" }
const _hoisted_26 = { class: "tw-mark-all-read-bar__text" }
const _hoisted_27 = {
  class: "card-body p-0",
  style: {"overflow":"auto"}
}
const _hoisted_28 = {
  key: 0,
  class: "tw-notifications-empty p-4 text-center"
}
const _hoisted_29 = { class: "font-size-13 text-muted mb-0" }
const _hoisted_30 = { class: "align-items-center bg-danger d-flex font-weight-light justify-center text-white tw-notification-badge" }
const _hoisted_31 = { class: "tw-header-user d-flex align-items-center" }
const _hoisted_32 = { class: "tw-header-user__trigger d-flex align-items-center" }
const _hoisted_33 = { class: "tw-header-user__info" }
const _hoisted_34 = { class: "tw-header-user__name" }
const _hoisted_35 = {
  key: 0,
  class: "tw-header-user__role"
}
const _hoisted_36 = { class: "col-1" }
const _hoisted_37 = { class: "col-11" }
const _hoisted_38 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_LanguageProfil = _resolveComponent("LanguageProfil")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, { class: "tw-header" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_btn, {
                "data-testid": "menu_button",
                class: "tw-nav-trigger",
                id: "icon",
                flat: "",
                icon: "menu",
                onClick: _ctx.collapseToggle
              }, null, 8, ["onClick"]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tw-header-logo__shine" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "teamWill Digital",
                  class: "tw-header-logo__img"
                })
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (this.userGroups && this.userGroups.length)
                  ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                      key: 0,
                      class: "btn btn-gray tw-header-profiles",
                      label: _ctx.$t('main.header.userProfilesList')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.userGroups, (item) => {
                              return (_openBlock(), _createBlock(_component_q_item, {
                                class: "theme-1",
                                key: item.resourceUid
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatAuthority(item.group)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    "data-testid": "theme_toggle_btn",
                    class: _normalizeClass(["tw-theme-switch", { 'tw-theme-switch--dark': _ctx.themeMode === 'dark' }]),
                    "aria-pressed": _ctx.themeMode === 'dark' ? 'true' : 'false',
                    "aria-label": _ctx.themeMode === 'dark' ? _ctx.$t('main.header.lightMode') : _ctx.$t('main.header.darkMode'),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleTheme && _ctx.onToggleTheme(...args)))
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", {
                      class: "tw-theme-switch__bg-icon tw-theme-switch__bg-icon--sun",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "4.2",
                          fill: "currentColor"
                        }),
                        _createElementVNode("path", {
                          d: "M12 2.8v2.2M12 19v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.8 12h2.2M19 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6",
                          stroke: "currentColor",
                          "stroke-width": "1.8",
                          "stroke-linecap": "round"
                        })
                      ])
                    ], -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("span", {
                      class: "tw-theme-switch__bg-icon tw-theme-switch__bg-icon--moon",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
                          fill: "currentColor"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        (_ctx.themeMode === 'light')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "4.2",
                                fill: "currentColor"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M12 2.8v2.2M12 19v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.8 12h2.2M19 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6",
                                stroke: "currentColor",
                                "stroke-width": "1.8",
                                "stroke-linecap": "round"
                              }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("path", {
                                d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
                                fill: "currentColor"
                              }, null, -1)
                            ]))]))
                      ])
                    ])
                  ], 10, _hoisted_6),
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.themeMode === 'dark' ? _ctx.$t('main.header.lightMode') : _ctx.$t('main.header.darkMode')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_btn_dropdown, {
                  class: "bg-none tw-nav-item tw-header-icon-btn tw-header-icon-btn--notifications no-padding",
                  flat: "",
                  "dropdown-icon": "notifications",
                  badge: _ctx.getDataSize,
                  onClick: _ctx.onClickNotif,
                  floating: ""
                }, _createSlots({
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("communication.comNotification.Notifications")), 1),
                            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("communication.comNotification.monthlyMonthly", {
                        days: _ctx.notificationRetentionDays,
                      })), 1),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-append" }, [
                                  _createElementVNode("button", {
                                    class: "bg-transparent btn no-border text-primary",
                                    type: "button"
                                  }, [
                                    _createElementVNode("i", { class: "fa fa-search" })
                                  ])
                                ], -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: "font-size-12 form-control no-border",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterInput) = $event)),
                                  placeholder: _ctx.$t('communication.comNotification.searchField')
                                }, null, 8, _hoisted_19), [
                                  [_vModelText, _ctx.filterInput]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_q_icon, {
                                  class: "material-icons-round",
                                  name: "menu",
                                  size: "sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_menu, {
                                      anchor: "bottom end",
                                      self: "top end",
                                      offset: [0, 10]
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, {
                                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.sortNotificationList('date')), ["self","stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("communication.comNotification.menu.sortByDate")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })), [
                                          [_directive_close_popup]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, {
                                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sortNotificationList('importance')), ["self","stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("communication.comNotification.menu.sortByImportance")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })), [
                                          [_directive_close_popup]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, {
                                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.sortNotificationList('unread')), ["self","stop"]))
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("communication.comNotification.menu.sortByUnread")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })), [
                                          [_directive_close_popup]
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("ul", _hoisted_22, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgStatusTabs, (tab) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "nav-item",
                                    key: tab
                                  }, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["nav-link", _ctx.selectedstatusTab === tab ? 'active' : '']),
                                      onClick: ($event: any) => (_ctx.onStatusTabChanged(tab))
                                    }, _toDisplayString(_ctx.$t(`communication.comNotification.buttons.${tab}`)), 11, _hoisted_23)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        (_ctx.getDataSize > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _cache[12] || (_cache[12] = _createElementVNode("span", {
                                  class: "tw-mark-all-read-bar__dot",
                                  "aria-hidden": "true"
                                }, null, -1)),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("communication.comNotification.unreadSummary", _ctx.getDataSize, { count: _ctx.getDataSize })), 1)
                              ]),
                              _createVNode(_component_q_btn, {
                                unelevated: "",
                                "no-caps": "",
                                dense: "",
                                size: "sm",
                                color: "primary",
                                class: "tw-mark-all-read-bar__action",
                                loading: _ctx.markAllAsReadLoading,
                                icon: "done_all",
                                label: _ctx.$t('communication.comNotification.markAllAsReadShort'),
                                onClick: _withModifiers(_ctx.markAllNotificationsAsRead, ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, {
                                    anchor: "top middle",
                                    self: "bottom middle"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("communication.comNotification.markAllAsRead")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["loading", "label", "onClick"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_27, [
                          (_ctx.filteredData.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("communication.comNotification.emptyRecent", {
                        days: _ctx.notificationRetentionDays,
                      })), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredData, (notification) => {
                            return (_openBlock(), _createBlock(_component_Notification, {
                              key: notification.resourceUid,
                              notification: notification,
                              destinataires: _ctx.recipients,
                              index: _ctx.getNotificationStoreIndex(notification)
                            }, null, 8, ["notification", "destinataires", "index"]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, [
                  (_ctx.getDataSize)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.getDataSize), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["badge", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_q_btn_dropdown, {
                  "content-class": "test",
                  class: "bg-none tw-nav-item tw-header-user__dropdown no-padding",
                  stretch: "",
                  flat: "",
                  "no-icon-animation": "",
                  "dropdown-icon": "",
                  floating: ""
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.displayName), 1),
                        (_ctx.primaryUserRole)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.primaryUserRole), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_q_avatar, {
                        size: "36px",
                        color: "amber",
                        "text-color": "white",
                        class: "tw-header-user__avatar"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.initials), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  "dropdown-arrow": _withCtx(() => [...(_cache[13] || (_cache[13] = []))]),
                  default: _withCtx(() => [
                    _createVNode(_component_LanguageProfil)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  "data-testid": "logout_btn",
                  class: "bg-none tw-nav-item tw-header-icon-btn no-padding",
                  flat: "",
                  icon: "logout",
                  onClick: _ctx.logout
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.confirmLogout,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmLogout) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_q_icon, {
                    name: "info",
                    color: "primary",
                    "text-color": "white",
                    size: "2rem"
                  })
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("main.confirmationDialog.message")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.confirmationButtonLabel,
                  color: "primary",
                  onClick: _ctx.onClickLogoutButton
                }, null, 8, ["label", "onClick"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.cancelButtonLabel,
                  color: "primary"
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}